import { useSelector } from 'react-redux';

import { getSourceParamsDefinitions, getTargetParamsDefinitions } from '.';

export const useTargetParamsDefs = () =>
    useSelector(getTargetParamsDefinitions);
export const useSourceParamsDefs = () =>
    useSelector(getSourceParamsDefinitions);
